import mapValues from 'lodash/mapValues';
import * as togglesCollection from './toggles';

const createFeatureToggle = toggle => (on, off) => (toggle() ? on : off);
export const generateFeatureToggles = toggles =>
  mapValues(toggles, createFeatureToggle);

export default generateFeatureToggles(togglesCollection);
